// removed by extract-text-webpack-plugin
module.exports = {"movable":"movable___1pWwA"};


//////////////////
// WEBPACK FOOTER
// ./src/utils/decorators/movable.m.scss
// module id = 877
// module chunks = 97